import { useState } from "react";
import { CalendarIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { parseLocal, ymd } from "@/lib/api";

/** value: "YYYY-MM-DD" | "" ; onChange("YYYY-MM-DD") */
export const DatePicker = ({ value, onChange, placeholder = "Pick a date", testid, allowClear = false }) => {
  const [open, setOpen] = useState(false);
  const d = value ? parseLocal(value) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" className="w-full justify-start font-normal bg-card" data-testid={testid}>
          <CalendarIcon className="h-4 w-4 mr-2 text-muted-foreground" />
          {d ? d.toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric", year: "numeric" }) : <span className="text-muted-foreground">{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-card" align="start">
        <Calendar mode="single" selected={d} defaultMonth={d} onSelect={(x) => { if (x) onChange(ymd(x)); setOpen(false); }} initialFocus />
        {allowClear && value && (
          <div className="p-2 border-t border-border">
            <Button type="button" variant="ghost" size="sm" className="w-full" onClick={() => { onChange(""); setOpen(false); }}>Clear date</Button>
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
};
